import type { GameService } from './types'

const game: GameService = {
    name: 'killer',
    category: 'minigames',
    placeholder: false,
    disable: true,
    onlineAvailable: false,
    // Killer assigns numbers via the starter selector; no match settings or
    // dart-setup selector are shown on the setup screen.
    hideDartSetup: true,
    form: [],
    content: {
        type: 'killer',
        duration: [15, 30],
        difficulty: 'beginner',
        player_count: '2 - 4',
        images: {
            banner: '',
            tile: '',
        },
    },
}

export default game
